/* eslint-disable no-unused-vars */
import azureSearchVM from './azureSearch.vm';
/* eslint-enable no-unused-vars */
export default class AzureSearchBootstrapper
{
    constructor(filterElementId, settingsElementId, facetSettingsElementId, rangeSlidersElementId, numRangeSlidersElementId, pageDataElementId, seoSettingsElementId)
    {
        let fltElId = filterElementId || 'frFilters';
        this.filterElement = document.getElementById(fltElId);
        if (this.filterElement)
        {
            let setElId = settingsElementId || 'search-settings';
            let facElId = facetSettingsElementId || 'facet-settings';
            let rslElId = rangeSlidersElementId || 'range-sliders';
            let nrsElId = numRangeSlidersElementId || 'num-range-sliders';
            let pgdElId = pageDataElementId || 'page-data';
            let seoElId = seoSettingsElementId || 'seo-settings';
            this.settingsElement = document.getElementById(setElId);
            this.facetSettingsElement = document.getElementById(facElId);
            this.rangeSlidersElement = document.getElementById(rslElId);
            this.numRangeSlidersElement = document.getElementById(nrsElId);
            this.pageDataElement = document.getElementById(pgdElId);
            this.seoSettingsElement = document.getElementById(seoElId);
            this.settings = null;
            this.facetSettings = null;
            this.rangeSliders = [];
            this.numRangeSliders = 0;
            this.pageData = {};
            this.searchVM = null;
            if (this.settingsElement && this.facetSettingsElement)
            {
                this.settings = JSON.parse(this.settingsElement.innerHTML);
                this.facetSettings = JSON.parse(this.facetSettingsElement.innerHTML);
                if (this.rangeSlidersElement) this.rangeSliders = JSON.parse(this.rangeSlidersElement.innerHTML);
                if (this.numRangeSlidersElement) this.numRangeSliders = (JSON.parse(this.numRangeSlidersElement.innerHTML)).numRangeFacets;
                if (this.pageDataElement) this.pageData = JSON.parse(this.pageDataElement.innerHTML);
                if (this.seoSettingsElement) this.seoSettings = JSON.parse(this.seoSettingsElement.innerHTML);
                this.searchVM = azureSearchVM.init(fltElId, this.settings, this.facetSettings, this.rangeSliders, this.numRangeSliders, this.pageData, this.seoSettings);
                console.log('filter application initialized');

                // Additional stuff can be done here, like doing something with the filters once they're fully initialized
            }
            else console.error('FILTER SETTINGS NOT FOUND');
        }
        else console.log('no filter elements on this page');
    }
};



// WEBPACK FOOTER //
// ./CMS/scripts/modules/azureSearch/azureSearch.bootstrapper.js